import { render, staticRenderFns } from "./prefeituras.vue?vue&type=template&id=32f00aa7"
import script from "./prefeituras.vue?vue&type=script&lang=js"
export * from "./prefeituras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports